import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import moment from 'moment';
import Loader from '../../../components/Common/Loader';
import useMove from '../Hooks/useMove';
import Card from '../../../components/Cards/Card';
import { Field } from '../../../components/Common/Field/Field';
import { useFormModal } from '../../../components/Modals/formModal.js/FormModal';
import MoveStateHistory from '../Shared/MoveStateHistory';
import { DestinationType } from '../../../api/Inventory/Entities/InventoryMovementEntities';
import { resolveMoveDetailBackTarget } from './moveDetailNavigation';
import { InventoryTab, inventoryTabTarget } from './inventoryTabNavigation';

export function DispenseMoveDetail({ match: { params, path } }) {
    const history = useHistory();
    const { t } = useTranslation();
    const { dispenseId, protocolId } = params
    const [move, isLoading] = useMove(dispenseId);
    const [HistoryModal, HistoryActions] = useFormModal({ FormContent: MoveStateHistory, size: 'lg' })

    if (move == null || move.id == 0) { return (<Loader isLoading={true}></Loader>) }

    const handleCancel = () => {
        const backTarget = resolveMoveDetailBackTarget({ path, protocolId })
        history.push(backTarget ?? inventoryTabTarget(InventoryTab.pharmacy))
    }

    const handleShowHistory = async () => {
        HistoryActions.Show({
            title: t('inventory.movements.commons.historyOfChanges'),
            initValue: { moveId: dispenseId }
        })
    }

    const columns = [
        { dataField: 'presentation', text: t('commons.description'), headerStyle: { width: '7rem' } },
        { dataField: 'lotNumber', text: t('inventory.commons.lotNumber'), headerStyle: { width: '3rem' } },
        { dataField: 'assignment.kitNumber', text: t('inventory.commons.kitNumber'), headerStyle: { width: '3rem' } },
        { dataField: 'quantity', text: t('commons.quantity'), headerStyle: { width: '3rem' } },
        { dataField: 'confirmedQuantity', text: t('inventory.dispense.confirmedQuantity'), headerStyle: { width: '3rem' } },
    ]

    return (<>
        <Card
            content={<>
                <Loader isLoading={isLoading}>
                    <div className='text-center'>
                        <label className="info-title info-title-lg">{t('inventory.dispense.protocolDispenseDispatchTitle')}</label>
                    </div>
                    {move.protocolDeleted &&
                        <div className="alert alert-warning text-center" role="alert">
                            {t('inventory.movements.commons.deletedProtocolNote')}
                        </div>}
                    <Row>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={'ID'} value={move.id} spaceType={'between'} />
                                <Field title={t('commons.type')} spaceType={'between'} value={t(`inventory.movements.moveType.${move.moveType?.toLowerCase()}`)} />
                            </div>
                        </Col>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={t('commons.status')} spaceType={'between'} value={t(`inventory.movements.moveState.${move.status}`)} />
                                <Field title={t('commons.date')} spaceType={'between'} value={moment(move.createAt).format("DD/MM/YYYY HH:mm")} />
                            </div>
                        </Col>
                        <Col md={4} sm={12}>
                            <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                <Field title={t('commons.patient')} spaceType={'between'}
                                    value={move?.destination?.destinationName}
                                />
                                <div>
                                    <button className="btn btn-secondary" onClick={handleShowHistory}>{t('inventory.movements.commons.historyOfChanges')}</button>
                                </div>
                            </div>
                        </Col>
                        {move.destination != null
                            && move.destination.destinationType == DestinationType.ProtocolPatient.Name
                            && <Col md={4} sm={12}>
                                <div className="info" style={{ justifyContent: 'space-between!important' }}>
                                    <Field title={t('commons.visit')} spaceType={'between'} value={move.destination.visitTitle} />
                                </div>
                            </Col>}
                        <Col sm={12}>
                            <div>
                                <hr />
                                <div className='text-center' style={{ marginTop: "1rem" }}>
                                    <strong className='info-label'>{t('inventory.commons.detail')}</strong>
                                </div>
                                <div style={{ height: '300px', overflow: 'hidden auto' }}>
                                    <BootstrapTable
                                        bordered={false}
                                        hover
                                        remote
                                        keyField='id'
                                        pagination={paginationFactory({
                                            sizePerPage: move?.items?.length ?? 0,
                                            totalSize: move?.items?.length ?? 0,
                                            hideSizePerPage: true
                                        })}
                                        onTableChange={() => { }}
                                        classes="table-spaced table-spaced-small"
                                        wrapperClasses="table-responsive"
                                        data={move.items}
                                        columns={columns}
                                        loading={isLoading}
                                        noDataIndication={() => <>{t("commons.noData")}</>}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <div style={{ textAlign: 'right', display: 'flex', justifyContent: 'end' }}>
                                <button className="btn btn-secondary" type="button" onClick={handleCancel}>{t('buttons.back')}</button>
                            </div>
                        </Col>
                    </Row>
                </Loader>
                <HistoryModal />
            </>}
        />
    </>)
}